import dayjs, { QUnitType } from "dayjs";
import utc from "dayjs/plugin/utc";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isBetween from "dayjs/plugin/isBetween";
import minMax from "dayjs/plugin/minMax";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import isoWeek from "dayjs/plugin/isoWeek";
import relativeTime from "dayjs/plugin/relativeTime";
import advancedFormat from "dayjs/plugin/advancedFormat";
import calendar from "dayjs/plugin/calendar";
import localeData from "dayjs/plugin/localeData";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(calendar);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(minMax);
dayjs.extend(quarterOfYear);
dayjs.extend(isoWeek);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(localeData);

export type { QUnitType };
export default dayjs;
